import { useState } from 'react';
import { useDebounce } from 'react-use';
import { KoobInputSelect } from '@koob/ui';
import { useBooking, useSearchParams } from 'hooks';

const LocationAwareSelect = ({
  placeholder,
  debounceTime = 500,
  name,
  options,
  shouldStoreWholeObject,
  shouldHideSelectedValues,
  onChangeSearchParams,
  mode,
  multiple,
  ...props
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { filters, setFilters } = useBooking();
  const [value, setValue] = useState(
    mode === 'state' ? filters[name] || [] : searchParams[name] || [],
  );

  useDebounce(
    () => {
      if (mode === 'state') {
        if (value.length !== 0 && filters[name] !== value) {
          setFilters((filters) => ({ ...filters, [name]: value }));
        }
      } else {
        // Changing a filter always jumps back to the first page.
        setSearchParams({ ...searchParams, [name]: value, page: undefined });
      }
    },
    debounceTime,
    [value],
  );

  const findOption = (rawValue) =>
    (options ?? []).find((option) => option.value === rawValue);

  const selectValue = multiple
    ? (Array.isArray(value) ? value : []).map((item) =>
        shouldStoreWholeObject ? item?.value : item,
      )
    : shouldStoreWholeObject
      ? value?.value
      : value;

  return (
    <KoobInputSelect
      value={selectValue}
      multiple={multiple}
      placeholder={placeholder}
      onValueChange={(newValue) => {
        if (multiple) {
          setValue(
            shouldStoreWholeObject ? newValue.map(findOption) : newValue,
          );
        } else {
          setValue(shouldStoreWholeObject ? findOption(newValue) : newValue);
        }
      }}
      options={options}
      {...props}
    />
  );
};

export default LocationAwareSelect;
